import { render, staticRenderFns } from "./BarGraph2D.vue?vue&type=template&id=4ffc52bf&scoped=true&"
import script from "./BarGraph2D.vue?vue&type=script&lang=js&"
export * from "./BarGraph2D.vue?vue&type=script&lang=js&"
import style0 from "./BarGraph2D.vue?vue&type=style&index=0&id=4ffc52bf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ffc52bf",
  null
  
)

export default component.exports